import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import { connect, useDispatch, useSelector } from "react-redux"

import { fetchStylecode, updateChoice } from "areas/product/store/actions"
import Select from "components/ui/select"
import { retry, isTestMode } from "helpers/application"
import { to_currency } from "helpers/number"

import StoneCards from "./stone-cards"

// const NumberPicker = loadable(
//   () => retry(() => import("./choice/number-picker")),
//   { ssr: false }
// )

const SwitchOptionsModal = loadable(
  () =>
    retry(() => import("areas/product/jewlr/modals/switch_options_half_modal")),
  { ssr: false }
)

const InternalUnifiedStonePicker = ({ pref, selectedValue, wizardData }) => {
  const [isLoadingStylecode, setIsLoadingStylecode] = useState(false)
  const styleCode = useSelector((state) => state.choices.style_code?.value)
  const dispatch = useDispatch()

  useEffect(() => {
    setIsLoadingStylecode(false)
  }, [styleCode])

  if (!["o1", "sc"].includes(pref)) return null

  let minNumberOfStones = null
  let maxNumberOfStones = null
  let pickerType = "Stones"

  if (pref === "sc" && wizardData?.min_stones && wizardData?.max_stones) {
    minNumberOfStones = wizardData.min_stones
    maxNumberOfStones = wizardData.max_stones
  } else if (wizardData?.options) {
    const availableOptions = wizardData.options.filter((opt) => !opt.disabled)
    if (availableOptions.length > 0) {
      const firstOption = availableOptions[0]
      const lastOption = availableOptions[availableOptions.length - 1]
      const extractNumber = (opt) =>
        Number((opt.title || opt.label || opt.value || "").match(/\d+/)?.[0]) ||
        ""
      const extractType = (opt) => {
        const text = opt.title || opt.label || opt.value || ""
        const match = text.match(/^\d+\s*(.+)$/)
        return match ? match[1].trim() : "Stones"
      }

      pickerType = extractType(firstOption)
      minNumberOfStones = extractNumber(firstOption)
      maxNumberOfStones = extractNumber(lastOption)
    }
  }

  const handleChange = (e) => {
    const { value } = e.target
    const option = (wizardData?.options || []).find((s) => s.value === value)
    if (option) {
      if (!isTestMode) {
        dataLayer.push({
          event: "changed-stone-quantity",
        })
      }

      if (option.style_code) {
        setIsLoadingStylecode(true)
        dispatch(fetchStylecode(option.style_code))
      } else {
        dispatch(updateChoice(pref, option, true))
      }
    }
  }

  const content =
    wizardData && !wizardData.disabled && wizardData.options ? (
      <div style={{ width: "144px" }}>
        <Select
          chevronClassName="top-10"
          className="border-grey-65 text-12 h-32 font-semibold focus:outline-none"
          name={pref}
          onChange={handleChange}
          value={selectedValue}
        >
          {wizardData.options.map((option) => {
            const displayName =
              pref === "sc"
                ? `${option.value} ${option.stone_count > 1 ? "Stones" : "Stone"}`
                : option.display_name
            return (
              <option key={`stone-${option.value}`} value={option.value}>
                {displayName}{" "}
                {option.price > 0 ? `(+${to_currency(option.price)})` : ""}
              </option>
            )
          })}
        </Select>
      </div>
    ) : // <NumberPicker
    //   ariaLabel={wizardData.heading?.title}
    //   data={wizardData}
    //   key={`number-picker-${pref}`}
    //   maxValue={maxNumberOfStones}
    //   minValue={minNumberOfStones}
    //   options={wizardData.options}
    //   pref={pref}
    //   setIsLoadingStylecode={setIsLoadingStylecode}
    // />
    null

  const subtitle =
    minNumberOfStones && maxNumberOfStones
      ? `Select between ${minNumberOfStones} and ${maxNumberOfStones} ${pickerType}`
      : null

  return (
    <>
      <SwitchOptionsModal />
      <div className="pt-10">
        <div className="tablet:px-6 flex flex-row items-center justify-between">
          <div className="flex flex-col">
            <p className="text-14 tablet:font-bold tablet:tracking-half mb-4 font-semibold uppercase text-black">
              {wizardData?.heading?.title}
            </p>
            {subtitle && <p className="text-12 text-grey-65">{subtitle}</p>}
          </div>
          <div className="flex-shrink-0">{content}</div>
        </div>
      </div>
      <StoneCards
        isLoadingStylecode={isLoadingStylecode}
        maxNumberOfStones={maxNumberOfStones}
        setIsLoadingStylecode={setIsLoadingStylecode}
      />
    </>
  )
}

InternalUnifiedStonePicker.propTypes = {
  pref: PropTypes.string,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  wizardData: PropTypes.object,
}

const mapStateToProps = (state, ownProps) => ({
  selectedValue: state.choices[ownProps.pref]
    ? state.choices[ownProps.pref].value
    : null,
  wizardData: state.wizard.data[ownProps.pref],
})

const UnifiedStonePicker = connect(mapStateToProps)(InternalUnifiedStonePicker)

export default UnifiedStonePicker
